module.exports = __webpack_public_path__ + "img/electricity.519f957.svg";